import { render } from "./PrizeContent.vue?vue&type=template&id=d35f9052"
import script from "./PrizeContent.vue?vue&type=script&lang=js"
export * from "./PrizeContent.vue?vue&type=script&lang=js"

import "./PrizeContent.vue?vue&type=style&index=0&id=d35f9052&lang=less"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__